module.exports = __webpack_public_path__ + "static/media/39.4a7c12e0.png";